module.exports = "<div class=\"ssf-accordion\">\n  <div class=\"ssf-accordion__head row\" (click)=\"toggleDetails()\">\n    <div  class=\"col-11 ssf-accordion__head_custom\">\n      <ng-content select=\"[head]\"></ng-content>\n    </div>\n    <div class=\"col-1 ssf-accordion__head_template\">\n      <ssf-details-button [shown]=\"shown\"></ssf-details-button>\n    </div>\n  </div>\n  <div class=\"ssf-accordion__body\" [@slideInOut]=\"animationState\" >\n    <ng-content select=\"[body]\"></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/accordion/accordion.component.html
// module id = 828
// module chunks = 3